<template>
    <div class="okraina-retail-select">

        <!-- Загрузка -->
        <template v-if="loading">
            <div class="text-center">
                <okraina-loader-inline />
            </div>
        </template>

        <template v-else>

            <!-- Ошибка загрузки -->
            <template v-if="loadingError">
                <okraina-illustration :picture="imageError" caption="Ошибка загрузки данных.">
                    <div class="btn btn1 slim" @click="retryLoad">
                        Повторить
                    </div>
                </okraina-illustration>
            </template>

            <template v-else>

                <okraina-control-input :classes="['slim']" placeholder="Поиск магазина" v-model="search" ref="input">
                    <template v-slot:left>
                        <div class="action">
                            <span class="icon fi fi-search"></span>
                        </div>
                    </template>

                    <template v-slot:right v-if="isNative || !!search">
                        <div class="action" v-if="isNative" @click="speechSearch">
                            <span class="icon fi fi-mic"></span>
                        </div>
                        <div class="action clear" v-if="!!search" @click="clear">
                            <span class="icon fi fi-close"></span>
                        </div>
                    </template>
                </okraina-control-input>

                <div v-show="!search" class="map-wrap">
                    <div class="map" ref="map">
                        <div class="loader" v-if="mapLoadig">
                            <okraina-loader-inline />
                        </div>
                    </div>
                </div>

                <div v-if="search" class="list">
                    <div class="item" v-for="item in searchItems" :key="item.FIELDS.ID"
                        @click="onItemClick(item.FIELDS.ID)" v-html="item.PROPS.ADDRESS">
                    </div>
                </div>


            </template>

        </template>



    </div>
</template>

<script>
import okrainaLoaderInline from "@/components/loader.inline.vue"
import okrainaIllustration from "@/components/illustration.vue";
import okrainaControlInput from "@/components/controls/input.vue";

import rest from "@/plugins/rest";
import bus from "@/plugins/bus";
import ymaps from 'ymaps';

import { mapGetters } from "vuex";

import imageErrorPath from "@/assets/images/error.svg";
import imagePlacemarkPath from "@/assets/images/placemark.png";

export default {
    name: "okraina-retail-select",
    components: {
        okrainaLoaderInline,
        okrainaIllustration,
        okrainaControlInput
    },
    data() {
        return {
            loading: true,
            loadingError: false,
            mapLoadig: true,
            items: [],
            mapInited: false,
            imageError: imageErrorPath,
            imagePlacemark: imagePlacemarkPath,

            search: ""
        }
    },

    props: {
        visible: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },

    computed: {
        ...mapGetters({
            siteSettings: "getSiteSettings",
            isNative: "isNativePlatform",
        }),

        apiKey() {
            return this.siteSettings ? this.siteSettings.YMAP_KEY : "";
        },

        mapRef() {
            return this.$refs.map;
        },

        searchItems() {

            let items = JSON.parse(JSON.stringify(this.items));

            if (this.search == "") {
                return items;
            }

            let words = this.search.split(/\s+/).filter(word => word !== '');

            items = items.filter(
                (item) => this.contains(item.PROPS.ADDRESS, words)
            );

            items.forEach(item => item.PROPS.ADDRESS = this.highlightSearch(item.PROPS.ADDRESS, words));
            return items;
        }
    },

    watch: {
        apiKey: function (newVal) {
            if (newVal) {
                setTimeout(() => {
                    this.initMap();
                }, 1);
            }
        },
        items: function (newVal) {
            if (newVal) {
                setTimeout(() => {
                    this.initMap();
                }, 1);

            }
        },
        mapRef: function (newVal) {
            if (newVal) {
                setTimeout(() => {
                    this.initMap();
                }, 1);
            }
        },

        visible: function (newVal) {
            if (newVal) {
                setTimeout(() => {
                    this.initMap();
                }, 1);
            }
        }

    },

    methods: {

        /**
         * Загружает данные
        */
        loadData() {
            this.loading = true;

            rest
                .call("company.shops", {
                    method: "post",
                    data: {
                        SELECT: ["ID", "NAME"],
                        FILTER: {
                            "!PROPERTY_AVAILABLE_IN_APP": false
                        },
                        ORDER: { "PROPERTY_ADDRESS": "ASC" }
                    },
                })
                .then((data) => {
                    if (data.SUCCESS) {
                        this.items = data.ITEMS;
                        this.loadingError = false;
                    } else {
                        //показываем сообщение об ошибке
                        bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: data.ERROR_TEXT });
                        this.loadingError = true;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        /**
         * Повторная попытка загрузки
         */
        retryLoad() {
            this.loadData();
        },

        /**
         * Инициализация карты
         */
        initMap() {

            if (!this.apiKey || this.items.length == 0 || this.mapInited || !this.$refs.map || !this.visible) {
                return;
            }

            this.mapInited = true;

            //загруажем API яндекс карт
            ymaps
                .load('https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=' + this.apiKey)
                .then(maps => {

                    this.mapLoadig = false;

                    //создаём точки на карте через кластер
                    let cluster = this.createCluster(maps);
                    let bounds = cluster.getBounds();
                    let boundsResult = maps.util.bounds.getCenterAndZoom(bounds, [this.$refs.map.offsetWidth, this.$refs.map.offsetHeight]);

                    //создаём карту (map Специально в data не заводим, чтобы было НЕ реактивным)
                    this.map = new maps.Map(this.$refs.map, {
                        center: boundsResult.center,
                        zoom: boundsResult.zoom,
                        controls: ['geolocationControl', 'zoomControl'],
                        behaviors: ['multiTouch', 'dblClickZoom', 'drag']
                    });
                    this.map.geoObjects.add(cluster);

                });

        },

        /**
         * Создаёт на карте точки
         */
        createCluster(maps) {

            //создаём кластер
            let clusterer = new maps.Clusterer({
                clusterIconColor: "#76B82B",
                zoomMargin: 80
            });

            this.items.forEach((item) => {

                let placemark = new maps.Placemark(
                    [parseFloat(item.PROPS.LATITUDE), parseFloat(item.PROPS.LONGITUDE)],
                    {
                        hintContent: item.FIELDS.NAME,
                        name: item.FIELDS.NAME,
                        address: item.PROPS.ADDRESS,
                        schedule: item.PROPS.WORKTIME,
                        shop_id: item.FIELDS.ID
                    },
                    {

                        balloonLayout: this.getBallonLayout(maps),
                        balloonContentLayout: this.getBallonContentLayout(maps),
                        balloonShadow: false,
                        balloonPanelMaxMapArea: 0,
                        iconLayout: 'default#image',
                        iconImageHref: this.imagePlacemark,
                        iconImageSize: [40, 40],
                        iconImageOffset: [-(40 / 2), -40]
                    }

                );
                clusterer.add(placemark);
            });

            return clusterer;
        },

        /*
        * Шаблон макета балуна
        */
        getBallonLayout(maps) {

            var max = 300;

            let vm = this;

            var MainBlockCustumBallonLayout = maps.templateLayoutFactory.createClass(
                '<div class="okraina-rsm-balloon-layout">' +
                '$[[options.contentLayout observeSize maxWidth=' + max + ']]' +
                '</div>', {
                /**
                 * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
                 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
                 * @function
                 * @name build
                 */
                build: function () {
                    this.constructor.superclass.build.call(this);

                    let parentElement = this.getParentElement();
                    this._$element = parentElement.querySelector('.okraina-rsm-balloon-layout');

                    let layout = this;
                    //смещаем балун
                    this.applyElementOffset();

                    //клик по иконке закрытия
                    let close = this._$element.querySelector('.close');
                    close.addEventListener('click', function (event) {
                        layout.onCloseClick(event);
                    });

                    //клик по иконке "Применить"
                    let btn = this._$element.querySelector('.btn-apply');
                    btn.addEventListener('click', function (event) {
                        let shopId = layout.getData().properties._data.shop_id;
                        vm.$store.dispatch("retail/setRetailShopId", shopId);
                        layout.onCloseClick(event);
                    });


                },

                /**
                 * Удаляет содержимое макета из DOM.
                 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
                 * @function
                 * @name clear
                 */
                clear: function () {

                    this.constructor.superclass.clear.call(this);
                },

                /**
                 * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
                 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                 * @function
                 * @name onSublayoutSizeChange
                 */
                onSublayoutSizeChange: function () {
                    MainBlockCustumBallonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                    if (!this._isElement(this._$element)) {
                        return;
                    }

                    //смещаем балун
                    this.applyElementOffset();

                    this.events.fire('shapechange');
                },

                /**
                 * Сдвигаем балун, чтобы "хвостик" указывал на точку привязки.
                 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                 * @function
                 * @name applyElementOffset
                 */
                applyElementOffset: function () {
                    let layout = this._$element.querySelector('.layout');

                    this._$element.style.left = "-" + (layout.offsetWidth / 2) + "px";
                    this._$element.style.top = (-this._$element.offsetHeight) + "px";

                },

                /**
                 * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
                 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                 * @function
                 * @name onCloseClick
                 */
                onCloseClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    this.events.fire('userclose');
                },

                /**
                 * Используется для автопозиционирования (balloonAutoPan).
                 * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
                 * @function
                 * @name getClientBounds
                 * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
                 */
                getShape: function () {

                    if (!this._isElement(this._$element)) {

                        return MainBlockCustumBallonLayout.superclass.getShape.call(this);
                    }

                    return new maps.shape.Rectangle(new maps.geometry.pixel.Rectangle([
                        [this._$element.offsetLeft, this._$element.offsetTop], [
                            this._$element.offsetLeft + this._$element.offsetWidth,
                            this._$element.offsetTop + this._$element.offsetHeight
                        ]
                    ]));
                },

                /**
                 * Проверяем наличие элемента (в ИЕ и Опере его еще может не быть).
                 * @function
                 * @private
                 * @name _isElement
                 * @param {jQuery} [element] Элемент.
                 * @returns {Boolean} Флаг наличия.
                 */
                _isElement: function (element) {
                    return !!element;
                }
            });
            return MainBlockCustumBallonLayout;
        },

        /*
        * Шаблон макета контента балуна
        */
        getBallonContentLayout(maps) {
            var MainBlockCustumBallonContentLayout = maps.templateLayoutFactory.createClass(
                '<div class="layout">' +

                '<div class="close">' +
                '<span class="icon fi fi-close"></span>' +
                '</div>' +

                '<div>' +
                '<div class="address"><span class="icon fi fi-location"></span> {{properties.address}}</div>' +
                '<div class="schedule"><span class="icon fi fi-time"></span> <b>Часы работы:</b> {{properties.schedule |raw }}</div>' +
                '</div>' +

                '<div class="btn btn1 btn-block btn-apply">Выбрать магазин</div>' +

                '</div>'
            );
            return MainBlockCustumBallonContentLayout;

        },


        /**
         * Распознование речи для значения
         */
        speechSearch() {

            bus.emit("OKRAINA_SPEECH_RECOGNITION_E_GET", {
                resolve: (text) => {
                    this.search = text;
                },
            });

        },

        /**
         * Стереть введённое значение
         */
        clear() {
            this.search = "";
        },

        /**
         * Клик по магазину из поиска
         */
        onItemClick(id) {
            this.$store.dispatch("retail/setRetailShopId", id);
        },

        /**
         * Проверяет содержит ли строка все подстроки
         */
        contains(text, words) {

            let cnt = 0;
            words.forEach(word => {
                if (text.toLowerCase().indexOf(word.toLowerCase()) >= 0) {
                    cnt++;
                }
            })

            return cnt == words.length;
        },

        /**
         * Подсветка слов в строке
         */
        highlightSearch(text, words) {

            words.forEach(word => {
                let index = text.toLowerCase().indexOf(word.toLowerCase());
                if (index >= 0) {
                    let substr = text.substring(index, index + word.length);
                    text = text.replace(substr, "<b>" + substr + "</b>");
                }
            })

            return text;
        }


    },

    created() {
        this.loadData();
    },

}

</script>

<style lang="scss">
.okraina-retail-select {

    .form-control-wrap {
        background-color: var(--color-header-control-background);
    }

    .map-wrap {
        position: absolute;
        top: 140px;
        left: 0px;
        right: 0px;
        height: calc(100% - 160px);
        padding: 0px var(--view-content-hor-padding);
        overflow: hidden;
        border-radius: 24px;
    }

    .map {
        position: relative;
        height: 100%;

        .loader {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    .list {

        border-radius: 24px;
        background: var(--color-block-background);
        box-shadow: 0 4px 10px 0 rgba(202, 202, 202, 0.25);

        padding: 8px 0px;

        .item {
            cursor: pointer;
            padding: 10px 20px;

            color: var(--color-text-dark);

            font-size: 14px;
            font-weight: 500;
            line-height: 140%;

            border-bottom: 1px solid var(--color-color7);

            &:last-of-type {
                border-bottom: 0px;
            }

            b {
                color: var(--color-color10);
                background-color: var(--color-color9);

            }

        }
    }
}

.okraina-rsm-balloon-layout {
    position: relative;
    width: 300px;


    .layout {
        background-color: var(--color-block-background);
        padding: 20px 15px;
        border-radius: 25px;
        line-height: 1.2;
        overflow: hidden;
        position: relative;
        width: 300px;
    }


    .address,
    .schedule {
        position: relative;
        padding-left: 35px;
        margin-bottom: 15px;
        padding-right: 45px;

        font-size: 16px;
        font-weight: 500;

        color: var(--color-text-dark);
    }

    .address .icon,
    .schedule .icon {
        position: absolute;
        top: 3px;
        left: 0px;
        font-size: 22px;
        color: var(--color-color10);
    }

    .schedule .icon {
        font-size: 18px;
    }

    .schedule b {
        color: var(--color-color10);
        display: block;
        margin-bottom: 5px;
    }


    .close {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 2;

        width: 28px;
        height: 28px;

        cursor: pointer;
        line-height: 1;

        .icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 17px;
            color: var(--color-color4);


        }
    }


}
</style>